import { render, staticRenderFns } from "./GeneratePayroll.vue?vue&type=template&id=4733c800&scoped=true&"
import script from "./GeneratePayroll.vue?vue&type=script&lang=js&"
export * from "./GeneratePayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733c800",
  null
  
)

export default component.exports